// GENERATED from ez-tree preset "Aspen Small" — Scripts/EzTree/PresetConverter.js
// Rerun (to see the drift vs. upstream ez-tree): npm start client.eztree.convertPresets
// NOT read-only: hand tweaks are expected; the converter is just the starting point.
//
// Sizing: targetHeight (metres) is THE scale knob — the generator scales the mesh uniformly to
// that height (unset = the root's default). value = rawHeight × ezTreeUnitToMeters, so the preset
// keeps its natural proportions (× 1.1 on value = +10% overall size); `swing` varies the height
// ±its fraction across the kind's variants. Both numbers are meant to be hand-tweaked.
// footprintRadiusRatio = observed width / observed height; resolved footprint radius =
// targetHeight × footprintRadiusRatio (so resizing via targetHeight keeps width proportional).
import {SceneryKindDef} from "../../@SceneryTypes.js";
import {EZTREE_ROOT_KIND_ID} from "../Kind_EzTree.js";

export const AspenSmall_KIND_ID = "ezTree_AspenSmall";

export const AspenSmallKind = new SceneryKindDef({
	id: "ezTree_AspenSmall",
	name: "Aspen Small",
	baseKindID: EZTREE_ROOT_KIND_ID,
	// Only the flat keys differing from the root's defaults (TreeOptions ctor defaults) are set —
	// everything else inherits the root.
	paramOverrides: {
		"branchLevels": 2,
		"branchAngle2": 35,
		"branchAngle3": 7,
		"branchChildren0": 4,
		"branchChildren1": 3,
		"branchChildren2": 3,
		"branchGnarliness0": 0.04,
		"branchGnarliness1": -0.010000000000000007,
		"branchGnarliness2": 0.12,
		"branchLength0": 23.99,
		"branchLength1": 3.36,
		"branchLength2": 7.699999999999999,
		"branchRadius0": 0.36999999999999994,
		"branchRadius1": 0.41,
		"branchStart1": 0.44999999999999996,
		"branchStart2": 0.32999999999999996,
		"branchStart3": 0,
		"branchTaper0": 0.37,
		"branchTaper1": 0.13,
		"leafCount": 13,
		"leafAngle": 30,
		"leafStart": 0.2,
		"leafType": "aspen",
		"barkType": "Bark002",
		"forceStrength": 0.010869565217391311,
		"targetHeight": 9.78,
	},
	footprintRadiusRatio: 0.269,
});
